module.exports = ".amount{\r\n    width:100%;\r\n}\r\n\r\n.link{\r\n    Font-Family:Arial,\"Open Sans\";\r\n\r\n}"